'use strict';

export default function chartConfig(scope) {
  'ngInject';

  return {
    chart: {
      height: 300,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    title: {text: '1ヶ月間の消費実績'},
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function () {
          let style = '';
          let day = scope.$filter('dayFilter')(this.value);
          if(day === '日') {
            style = 'color: #ff3131';
          } else if(day === '土') {
            style = 'color: #3737ff';
          }

          return `<span style="${style}">${scope.$filter('date')(this.value, 'M/d')} (${day})</span>`;
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量 [kWh]'
      }
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      borderWidth: 0,
      reversed: true
    },
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + scope.$filter('date')(this.x, 'MM月dd日') + "</tspan>";

        for (let point of this.points) {
          tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
          tip_format += point.y + " kWh";
          tip_format += "</span>";
        }

        return tip_format;
      }
    },
    plotOptions: {column: {grouping: true}},
    series: []
  };
}



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/active/monthly/compare-graph-monthly-active.config.js